import { createFileRoute, redirect } from '@tanstack/react-router'

import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import { FEATURE_DISCOVER_ADVANCED_FILTERS } from '@/core/constants/features'
import { getPagePadding } from '@/core/utils/getPagePadding'
import { DiscoverSearch } from '@/discover/components/DiscoverSearch/DiscoverSearch'

export const Route = createFileRoute('/_learning/discover/search/$query')({
  beforeLoad: ({ context, params }) => {
    if (!context.user?.features.includes(FEATURE_DISCOVER_ADVANCED_FILTERS)) {
      return
    }

    throw redirect({
      replace: true,
      search: { query: params.query },
      to: '/discover/channels',
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <StudentAppPagePadding {...getPagePadding()} maxW="unset">
      <DiscoverSearch />
    </StudentAppPagePadding>
  )
}
